<template>
   <v-navigation-drawer app
        expand-on-hover
        clipped
        clipped-left
    >
        <v-list
        nav
        dense
        >
            
            <v-list-item link @click="$router.push({ name: 'Lists' })">
                <v-list-item-icon>
                <v-icon>mdi-view-list</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Lists</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="$router.push({ name: 'Settings' })">
                <v-list-item-icon>
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Twilio Settings</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="$router.push({ name: 'phone_number_settings' })">
                <v-list-item-icon>
                    <v-icon>mdi-pound</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Phone Numbers</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="$router.push({ name: 'phone_settings' })">
                <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Voice Settings</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="$router.push({ name: 'audio_files' })">
                <v-list-item-icon>
                    <v-icon>mdi-volume-high</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Audio Files</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item link @click="toggleSettings">
                <v-list-item-icon>
                    <v-icon>mdi-forum</v-icon>
                </v-list-item-icon>
                <v-list-item-title>SMS Settings</v-list-item-title>
            </v-list-item> -->

            


            <!-- <v-list-item link>
                <v-list-item-icon>
                <v-icon>mdi-star</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Starred</v-list-item-title>
            </v-list-item> -->
        </v-list>

        <template v-slot:append>
            <v-list
            nav
            dense
            >
                
                <v-list-item link @click="app.logOut()">
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Log Out</v-list-item-title>
                </v-list-item>
            </v-list>
        </template>
        
        <!-- <settings></settings> -->

        <!-- NEW LIST DIALOG -->
        <v-dialog :value="this.lists.show_create_dialog" width="500" persistent>
            <v-card>
                <v-card-title class="text-h5 primary">
                    Create a List
                </v-card-title>
                <v-card-text>
                    <p class="mt-8 mb-6">Enter a name for your new list below.</p>
                    <v-text-field v-model="new_list.post_title" outlined label="List Name"></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="lists.show_create_dialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" text @click="createList()" :loading="saving">
                        Create
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-navigation-drawer>
</template>

<script>
import { useAppStore } from "../stores/app"
import { useUserStore } from "../stores/user"
import { useListsStore } from "../stores/lists"
// import Settings from './Settings.vue'



export default {
	name: 'NavigationDrawer',
    created() {
        this.app = useAppStore()
        this.user = useUserStore()
        this.lists = useListsStore()
    },
    data: () => {
        return {
            app: null,
            user: null,
            lists: null,
            new_list: {
                ID: null,
                post_title: ""
            },
            saving: false
        }
    },
    methods: {
        toggleSettings: function() {
            this.user.show_user_settings = !this.user.show_user_settings
        },
        createList: function () {
            this.saving = true
            this.app.req.post('lists', this.new_list).then(data => {
                this.lists.lists = data
                this.saving = false
                // this.lists.fetchLists()
                this.lists.show_create_dialog = false
            })
        },
        // maybeCreateList: function(e) {
        //     if(e.keyCode == 13)
        //         this.createList()
        // },
    },
    components: {
        // Settings
    }
}
</script>

<style scoped>
.v-list-item {
	cursor: pointer;
}
</style>
